import _ from 'lodash';
import { PaymentMethodTypeEnum } from '@/domain/paymentMethod/PaymentMethodTypeEnum';

const paymentMethodTypeToBookingChannelPaymentMethodType = {
  creditCard: 'creditCard',
  businessAccount: 'businessAccount',
};

// Booking channels (by humanReadableId) that should only ever offer business account payment methods.
const BUSINESS_ACCOUNT_ONLY_BOOKING_CHANNELS = ['doylescab'];

export class AllowedPaymentMethodDelegate {
  static isCreditCardPaymentMethodAllowed({ allowedPaymentMethods }) {
    return allowedPaymentMethods.some(paymentMethod => paymentMethod.type === 'creditCard');
  }

  static resolveAllowedPaymentMethods({ allowedPaymentMethods, paymentMethods, humanReadableId }) {
    const allowedPaymentMethodTypes = allowedPaymentMethods.map(paymentMethod => paymentMethod.type);

    const paymentMethodsToReturn = paymentMethods.map(paymentMethod => {
      if (allowedPaymentMethodTypes.includes(paymentMethodTypeToBookingChannelPaymentMethodType[paymentMethod.type])) {
        return paymentMethod;
      }
    })

    if (allowedPaymentMethodTypes.includes('cash')) { paymentMethodsToReturn.unshift({ type: 'cash', title: 'cash', brand: 'cash', paymentMethodType: 'cash', defaultPayment: false, },); }

    const resolvedPaymentMethods = this.payemntMethodsFactory(_.compact(paymentMethodsToReturn));

    if (BUSINESS_ACCOUNT_ONLY_BOOKING_CHANNELS.includes(humanReadableId)) {
      return resolvedPaymentMethods.filter(paymentMethod => paymentMethod.type === PaymentMethodTypeEnum.BUSINESS_DISPATCH_INVOICE);
    }

    return resolvedPaymentMethods;
  }

  static payemntMethodsFactory(paymentMethods) {
    return paymentMethods
    .filter(paymentMethod => paymentMethod.type)
    .map(paymentMethod => ({
      ...paymentMethod,
    }));
  }
}
